module.exports = __webpack_public_path__ + "static/img/scarborough1.fc98550.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/scarborough1.jpg
// module id = 132
// module chunks = 9